import React, { useState } from 'react';
import { postNewData } from '../../redux/action/customFile';
import { useHistory } from 'react-router-dom';
import './Agent.css';

export default function AgentNew() {
  const _formData = {
    agentName: '',
    phoneNumber: ''
  };
  const [formData, setFormData] = useState(_formData);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const history = useHistory();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: name === 'phoneNumber' ? value : value.toUpperCase(),
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.agentName) {
      newErrors.agentName = 'Agent name is required';
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!/^\d{11}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Phone number must be 11 digits';
    }
    return newErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setMessage({ type: 'error', text: 'Please correct the highlighted fields.' });
      return;
    }
    setSubmitting(true);
    postNewData(
      formData,
      "agent/create/new",
      (data) => {
        setSubmitting(false);
        setMessage({ type: 'success', text: data.message || 'Agent created successfully.' });
        setFormData(_formData);
      },
      (err) => {
        setSubmitting(false);
        setMessage({ type: 'error', text: 'Internal error: ' + err });
      }
    );
  };

  return (
    <div className="ag-page">
      <div className="ag-header">
        <div>
          <h3>New agent</h3>
          <p>Add a booking agent to Hamsyl Travel operations.</p>
        </div>
        <button type="button" className="ag-ghost" onClick={() => history.push('/agent/list/table')}>
          View agent list
        </button>
      </div>

      {message.text && <div className={`ag-banner ${message.type}`}>{message.text}</div>}

      <div className="ag-card">
        <div className="ag-card-head">
          <h4>Agent details</h4>
          <p>Name and an 11-digit phone number are required.</p>
        </div>
        <form className="ag-form" onSubmit={handleSubmit}>
          <div className="ag-field">
            <label htmlFor="agentName">Agent name</label>
            <input
              id="agentName"
              type="text"
              name="agentName"
              value={formData.agentName}
              onChange={handleInputChange}
              className={errors.agentName ? 'invalid' : ''}
              placeholder="e.g. AL MADINA TRAVEL"
            />
            {errors.agentName && <p className="ag-error">{errors.agentName}</p>}
          </div>
          <div className="ag-field">
            <label htmlFor="phoneNumber">Phone number</label>
            <input
              id="phoneNumber"
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              className={errors.phoneNumber ? 'invalid' : ''}
              placeholder="08000000000"
            />
            {errors.phoneNumber && <p className="ag-error">{errors.phoneNumber}</p>}
          </div>
          <div className="ag-actions">
            <button type="submit" className="ag-submit" disabled={submitting}>
              {submitting ? 'Saving…' : 'Create agent'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
